import { useTranslate, IResourceComponentsProps, useApiUrl, useCustom } from "@pankod/refine-core";
import {
    Col,
    Edit,
    Form,
    FormInstance,
    Input,
    Select,
    Typography,
    useForm,
} from "@pankod/refine-antd";
import { Tabs } from 'antd';

import "react-mde/lib/styles/css/react-mde-all.css";

import { IRoom } from "interfaces";
import React from "react";

const { Text } = Typography;

const col_center_half_xs = { span: 24, offset: 0 }
const col_center_full_lg = { span: 12, offset: 6 }
export const RoomCreate: React.FC<IResourceComponentsProps> = () => {
    const t = useTranslate();

    const { formProps, saveButtonProps, queryResult, form, formLoading } = useForm<IRoom>({ 'redirect': 'edit' });

    const onFinish = (values: any) => {
        return (
            formProps.onFinish &&
            formProps.onFinish({
                // ...values,
                birth: Math.trunc(Number(form.getFieldValue('birth')) / 1_000),
            })
        );
    };

    return (
        <Edit saveButtonProps={saveButtonProps} title={`${t('buttons.create')} ${t('menu.rooms')}`}>
            <Tabs defaultActiveKey="1" centered>
                <Tabs.TabPane forceRender tab={`${t('rooms.room')}`} key="1">
                    <Col xs={col_center_half_xs} lg={col_center_full_lg} >
                        {!formLoading && <RoomForm form={form} queryResult={queryResult} formLoading={formLoading} formProps={formProps} onFinish={onFinish} />}
                    </Col>
                </Tabs.TabPane>
            </Tabs>
        </Edit>
    );
};

interface FunctProps extends IResourceComponentsProps {
    formProps: any;
    form: FormInstance;
    queryResult: any;
    formLoading: any;
    onFinish({ }): any;
}

const RoomForm: React.FC<FunctProps> = (props) => {
    const t = useTranslate();
    const { formProps, form, queryResult, formLoading, onFinish } = props
    const apiUrl = useApiUrl();

    // Roomtypes
    const { data: roomtypes_data } = useCustom<any>({
        url: `${apiUrl}/roomtypes`,
        method: "get",
    });

    return (
        <Form {...formProps} layout="vertical">

            <Form.Item label={t("rooms.name")} name="name" rules={[{ required: true }]}>
                <Input />
            </Form.Item>

            <Form.Item label={<><Text>{t("rooms.classification")}</Text>&nbsp;
            </>} name="roomtype" rules={[{ required: true }]}>
                <Select options={roomtypes_data?.data?.map((e: any) => ({ value: e.id, label: e.name }))}
                    onChange={(e: any, o: any) => form?.setFieldsValue({ 'roomtype': o?.value })}
                />
            </Form.Item>

        </Form>
    );
};
